// Import model
import { FormLayout } from '../models/FormLayout';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)
import { GridFormLayoutSerializer } from './GridFormLayoutSerializer';

/**
 * Serializer for FormLayout - handles JSON serialization and deserialization with type validation
 */
export class FormLayoutSerializer {
  /**
   * Deserializes a JSON string into a FormLayout instance
   */
  static deserialize(json: string): FormLayout {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FormLayout instance
   */
  static fromObject(obj: any): FormLayout {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FormLayout');
    }

    // Handle polymorphic deserialization using discriminator
    const discriminator = obj['_t'];

    switch (discriminator) {
      case 'GridFormLayout':
        return GridFormLayoutSerializer.fromObject(obj);
      default:
        // Fall through to base type deserialization
        break;
    }

    const instance: FormLayout = {
      breakpoint: obj['Breakpoint'] as string,
      t: obj['_t'] as string,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FormLayout instances
   */
  static deserializeArray(json: string): FormLayout[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FormLayout instance to a JSON string
   */
  static serialize(instance: FormLayout): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FormLayout instance to a plain object
   */
  static toObject(instance: FormLayout): any {
    return {
      'Breakpoint': instance.breakpoint,
      '_t': instance.t,
    };
  }

  /**
   * Serializes an array of FormLayout instances to a JSON string
   */
  static serializeArray(instances: FormLayout[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
